import * as React from "react";
import { observer } from "mobx-react";
import { useContext } from "react";
import { ContactViewStoreContext } from "../../context/store";
import { Input, Form } from "antd";

export const AddressFormItem = observer(() => {
  const store = useContext(ContactViewStoreContext);

  return (
    <Form.Item label="住所">
      <Input
        value={store.address}
        onChange={e => {
          store.address = e.target.value;
        }}
      />
    </Form.Item>
  );
});
